/**
** JAVASCRIPTS
** Name: Header
********************************************************************************/

(function() {
  'use strict';


  if(document.querySelector('.js-header')) {


    /**
    ** Variables
    ****************************************/

    const $html   = document.querySelector('html');
    const $header = document.querySelector('.js-header');
    const $open   = document.querySelector('.js-header-open');
    const $close  = document.querySelector('.js-header-close');


    /**
    ** Events
    ****************************************/

    $open.addEventListener('click', (event)=>{
      event.preventDefault();
      $html.classList.add('header-panel');
    });

    $close.addEventListener('click', (event)=>{
      event.preventDefault();
      $html.classList.remove('header-panel');
    });


  }

})();
